import { render, staticRenderFns } from "./catalog-type-page.vue?vue&type=template&id=c592d48e&"
import script from "./catalog-type-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-type-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports